import { render, staticRenderFns } from "./PaginationRow.vue?vue&type=template&id=71c82edc&scoped=true"
import script from "./PaginationRow.vue?vue&type=script&lang=js"
export * from "./PaginationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c82edc",
  null
  
)

export default component.exports